import classNames from 'classnames'
import React, { ReactNode, useEffect, useRef } from 'react'

export interface AnimatedHeightContainerProps {
    children?: ReactNode
    className?: string
}

export const AnimatedHeightContainer = (props: AnimatedHeightContainerProps): JSX.Element => {
    const elementRef = useRef<HTMLElement | null>(null)
    const className: string = classNames('cart', props.className)

    const setCartHeight: () => void = (): void => {
        document.documentElement.style.setProperty('--cart-height', elementRef.current?.offsetHeight + 'px')
    }

    useEffect(() => {
        setCartHeight()
        window.addEventListener('resize', setCartHeight)

        return (): void => {
            window.removeEventListener('resize', setCartHeight)
        }
    }, [])

    useEffect(() => {
        setCartHeight()
    }, [props.children])

    const setElementRef = (el: HTMLElement | null): void => {
        if (el && elementRef.current !== el) {
            elementRef.current = el
        }
    }

    return (
        <div className={className} ref={setElementRef}>
            {props.children}
        </div>
    )
}
